<template>
  <div class="task-selector">
    <el-cascader
      v-if="!readOnly"
      v-model="goalUserTaskIds"
      :options="options"
      @active-item-change="onItemChange"
      @input="onItemSelected"
      filterable
      clearable
      :props="{}">
    </el-cascader>
    <div class="list my-2 mr-4" style="border: 2px dashed #e4e7ed; min-height: 50px; border-radius: 6px">
      <div class="list-inner p-1" style="border: none">
        <TaskListItem
          v-if="task"
          class="item task mx-auto"
          style="width: 280px"
          :is-editable="false"
          :data-element-id="this.taskId"
          :data-goal-id="this.goalId"
          :goal-id="this.goalId"
          :lane-id="null"
          :lane-assigned-user-id="this.memberId /* HACK */"
          :member-id="this.memberId"
          :task="task" />
        <div v-else style="color: #e4e7ed; text-align: center;">
          Please select task (or drop task here)
        </div>
      </div>
    </div>
    <!-- <pre class="mini-pre">{{goalUserTaskIds}}</pre> -->
  </div>
</template>

<script>
import TaskListItem from '@/components/GoalPage/Elements/TaskListItem'
// TODO: Drop target

export default {
  props: {
    readOnly: { type: Boolean, default: false },
    value: {}
  },
  data: () => ({
    goalUserTaskIds: null,
    options: []
  }),
  created() {
    this.goalUserTaskIds = [ this.value.goalId, this.value.memberId, this.value.taskId ];
  },
  mounted() {
    this.initOptions()
  },
  computed: {
    user_goal_settings() {
      return this.$models.userGoalSettings.subscribeList();
    },
    goal_list_meta_without_deleted() {
      // TODO: Filter deleted (see Menubar.vue)
      return this.user_goal_settings
        .itemsAsArray();
    },
    task() {
      if ( this.goalId && this.memberId && this.taskId ) {
        return this.$models.task
          .with({ goalId: this.goalId, memberId: this.memberId })
          .getNodeFull( this.taskId )
      }
      return null
    },
    goalId()   { return this.goalUserTaskIds[0] },
    memberId() { return this.goalUserTaskIds[1] },
    taskId()   { return this.goalUserTaskIds[2] },
  },
  methods: {
    initOptions() {
      this.options = this.goal_list_meta_without_deleted.map(goal => {
        return {
          value: goal.$id,
          label: goal.cachedName,
          children: []
        }
      })
    },

    onItemChange(selection) {
      console.log("onItemChange", selection);
      if ( selection[1] || selection[2] ) {
        return
      }

      const goalId = selection[0]
      let tasklist = this.$models.task.with({ goalId }).get_lane_task_list()

      let commitment_meta_list = this.$models.commitmentMeta.with({ goalId }).getList()

      Promise.all([tasklist.$promise, commitment_meta_list.$promise]).then(() => {
        let data = commitment_meta_list.itemsAsArray().map(commitment => {
          let children = tasklist.items[ commitment.$id ].map(task => {
            return { label: task.name, value: task.$id }
          })
          return {
            label: commitment.name,
            value: commitment.assignedUserId, // commitment.$id,
            children: children
          }
        })

        // console.log("data", data);
        let target = this.options.find(item => item.value === goalId );
        target.children = data;
      })
    },

    onItemSelected() {
      console.log("onItemSelected");
      this.$emit('input', {
        goalId:   this.goalUserTaskIds[0],
        memberId: this.goalUserTaskIds[1],
        taskId:   this.goalUserTaskIds[2],
        commitmentId: null, // TODO
      })
    }
  },
  components: {
    TaskListItem
  }
}
</script>

<style>
</style>
